<template>

  <div>

    <div class="project-intro">
      <div class="preview">
        <img src="../../assets/portfolio/bbdc-screens.png" alt="Broadway Bound Dance Centre">
      </div>
      <div class="intro-text">
        <p>
          <a href="https://broadwaybound.dance/" target="blank">Broadway Bound Dance Centre</a> 
          needed a new look. So we put together a new logo, website, and online store! Now students 
          and prospective customers could learn more about them, check their dance schedules, or buy shirts and apparel. 
          They also wanted to be able to make their own updates, so I was sure to make things 
          simple for them, using WordPress as their back-end CMS.
        </p>
        <ul>
          <li>Branding</li>
          <li>Product Design</li>
          <li>Development</li>
        </ul>
      </div>
    </div>
    <div class="case-study">
      <div class="browser bar">
        <img src="../../assets/portfolio/bbdc-1.jpg" alt="Broadway Bound Dance Centre">
      </div>
      <div class="browser">
        <img src="../../assets/portfolio/bbdc-scene-1.jpg" alt="Broadway Bound Dance Centre">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/bbdc-2.jpg" alt="Broadway Bound Dance Centre">
      </div>
      <!-- <div class="browser bar">
        <img src="../../assets/portfolio/bbdc-3.jpg" alt="Broadway Bound Dance Centre">
      </div> -->
      <div class="browser bar">
        <img src="../../assets/portfolio/bbdc-4.jpg" alt="Broadway Bound Dance Centre">
      </div>
      <!-- <div class="browser bar">
        <img src="../../assets/portfolio/bbdc-5.jpg" alt="Broadway Bound Dance Centre">
      </div> -->
      <!-- <div class="browser">
        <img src="../../assets/portfolio/bbdc-mobile.jpg" alt="Broadway Bound Dance Centre">
      </div> -->
      <div class="browser">
        <img src="../../assets/portfolio/bbdc-tablet-and-mobile.jpg" alt="Broadway Bound Dance Centre">
      </div>
    </div>

    <div class="project-outro">
      <div class="outro-text">
        <h2>WordPress &amp; Woocommerce</h2>
        <p>
          Since I worked so closely with the client, making sure to follow their new brand guidelines,
          they were very happy with the way their site turned out. This site was designed to be simple 
          and straightforward, allowing their users an easy and enjoyable visit or shopping experience. 
          Under the hood the site is no different, built on the ever-popular CMS WordPress and 
          paired with the powerful WooCommerce shopping platform, this site is built for ease.
        </p>
      </div>
      <div class="outro-img">
        <img src="../../assets/portfolio/wordpress-woocommerce.png" alt="wordpress and woocommerce">
      </div>
    </div>

  </div>


  </div>

</template>

<script>
export default {
  name: "agentstudio",
  props: ["title", "subtitle", "hero"]
};
</script>

<style scoped lang="scss">
</style>
